export const initiatives = [
  {
    id: 1,
    title: 'Für die Anerkennung des Staates Palästina',
    committee: 'Komitee Völkerrecht',
    reference: 'UeBest. Art. 197 Ziff. 17',
    preliminaryReview: '30.09.2025',
    collectionStart: '14.10.2025',
    collectionEnd: '14.04.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 197 Ziff. 17: Anerkennung des Staates Palästina

1 Die Schweiz anerkennt Palästina als souveränen und unabhängigen Staat.
2 Wird die Anerkennung des Staates Palästina von Volk und Ständen angenommen, so richtet der Bundesrat innerhalb von drei Monaten nach Feststellung des Abstimmungsergebnisses eine entsprechende Erklärung an den Generalsekretär oder die Generalsekretärin der UNO und an die Generalversammlung der Vereinten Nationen.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 2,
    title: 'Für eine spendenbasierte Fluchthilfe und Schutzgewährung (Fluchthilfe-Initiative)',
    committee: 'Schweizer Fluchthilfe Komitee',
    reference: 'UeBest. Art. 198 Ziff. X',
    preliminaryReview: '15.10.2025',
    collectionStart: '20.10.2025',
    collectionEnd: '20.04.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 198: Fluchthilfe und Schutzgewährung

1 Die Schweiz gewährt flüchtenden Personen Schutz und Unterstützung.
2 Personen, die anderen bei der Flucht helfen, dürfen nicht bestraft werden, wenn sie dies aus humanitären Gründen tun.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 3,
    title: 'Ja zum Schutz vor missbräuchlichen Mieten (Mietpreis-Initiative)',
    committee: 'Mietervereinigung Schweiz',
    reference: 'UeBest. Art. 129 Ziff. X',
    preliminaryReview: '05.11.2025',
    collectionStart: '10.11.2025',
    collectionEnd: '10.05.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 129: Mieterschutz

1 Der Bund erlässt Vorschriften gegen missbräuchliche Mietzinse und Mietbedingungen.
2 Die Kantone setzen Massnahmen zur Kontrolle und Sanktionierung missbräuchlicher Mieten um.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 4,
    title: 'Für bewilligungsfreie Solaranlagen',
    committee: 'Solar Coalition',
    reference: 'UeBest. Art. 76 Ziff. X',
    preliminaryReview: '01.11.2025',
    collectionStart: '06.11.2025',
    collectionEnd: '06.05.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 76: Erneuerbare Energie

1 Solaranlagen auf Dachflächen sind bewilligungsfrei.
2 Die Kantone setzen diese Bestimmung um und erlassen entsprechende Verordnungen.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 5,
    title: 'Starke Gesellschaft und Wirtschaft dank Elternzeit (Familienzeit-Initiative)',
    committee: 'Familieninitiative Schweiz',
    reference: 'UeBest. Art. 8 Ziff. X',
    preliminaryReview: '10.11.2025',
    collectionStart: '15.11.2025',
    collectionEnd: '15.05.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 8: Elternzeit

1 Eltern haben Anspruch auf insgesamt 18 Monate bezahlte Elternzeit, die in den ersten drei Jahren nach der Geburt oder Adoption genommen werden kann.
2 Der Bund legt die Details der Finanzierung fest.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 6,
    title: 'Für eine volksorientierte Politik (No Lobbying)',
    committee: 'Transparency Switzerland',
    reference: 'UeBest. Art. 153 Ziff. X',
    preliminaryReview: '20.11.2025',
    collectionStart: '25.11.2025',
    collectionEnd: '25.05.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 153: Transparenz in der Politik

1 Lobbying-Aktivitäten müssen vollständig transparent gemacht werden.
2 Personen, die politische Entscheidungen beeinflussen, müssen ihre finanziellen Interessen offenlegen.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 7,
    title: 'Für eine finanziell starke, souveräne und verantwortungsvolle Schweiz (Bitcoin-Initiative)',
    committee: 'Swiss Bitcoin Initiative',
    reference: 'UeBest. Art. 99 Ziff. X',
    preliminaryReview: '25.11.2025',
    collectionStart: '30.11.2025',
    collectionEnd: '30.05.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 99: Kryptowährungen

1 Bitcoin und andere Kryptowährungen sind als gesetzliches Zahlungsmittel anerkannt.
2 Der Bund schafft einen rechtlichen Rahmen für den Umgang mit Kryptowährungen.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 8,
    title: 'Für einen nachhaltigen und zukunftsgerichteten Finanzplatz Schweiz (Finanzplatz-Initiative)',
    committee: 'Sustainable Finance Switzerland',
    reference: 'UeBest. Art. 98 Ziff. X',
    preliminaryReview: '28.11.2025',
    collectionStart: '03.12.2025',
    collectionEnd: '03.06.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 98: Nachhaltiger Finanzplatz

1 Der Bund sorgt dafür, dass der Finanzplatz Schweiz nachhaltig ausgerichtet ist.
2 Finanzinstitute müssen ihre Klima- und Nachhaltigkeitsrisiken offenlegen.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 9,
    title: 'Für gentechnikfreie Lebensmittel (Lebensmittelschutz-Initiative)',
    committee: 'Bio Schweiz Coalition',
    reference: 'UeBest. Art. 104 Ziff. X',
    preliminaryReview: '05.12.2025',
    collectionStart: '10.12.2025',
    collectionEnd: '10.06.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 104: Gentechnikfreiheit

1 Gentechnisch veränderte Lebensmittel dürfen in der Schweiz nicht produziert oder importiert werden.
2 Ausnahmen sind nur für medizinische Zwecke möglich.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  },
  {
    id: 10,
    title: 'Für den Beitritt der Schweiz zum Vertrag der Vereinten Nationen über das Verbot von Atomwaffen (Atomwaffenverbots-Initiative)',
    committee: 'No Nuclear Weapons Switzerland',
    reference: 'UeBest. Art. 54 Ziff. X',
    preliminaryReview: '08.12.2025',
    collectionStart: '13.12.2025',
    collectionEnd: '13.06.2027',
    form: 'Eidg. Volksinitiative (Ausgearbeiteter Entwurf)',
    fullText: `Die Bundesverfassung wird wie folgt geändert:

Art. 54: Atomwaffenverbot

1 Die Schweiz tritt dem Vertrag über das Verbot von Kernwaffen der Vereinten Nationen bei.
2 Der Bundesrat leitet das Beitrittsverfahren innerhalb von sechs Monaten nach Annahme der Initiative durch Volk und Stände ein.`,
    legalBasis: 'Art. 139, 139b BV, Art. 68 ff. VPR'
  }
];

